export const ERROR_CODES = {
  CREATE_ORDER_ERROR: 'CREATE_ORDER_ERROR',
  INVALID_CREDIT_CARD_ERROR: 'INVALID_CREDIT_CARD_ERROR',
  DECLINED_PAYMENT_METHOD_ERROR: 'DECLINED_PAYMENT_METHOD_ERROR',
  PAYMENT_TOKEN_ERROR: 'PAYMENT_TOKEN_ERROR',
  REFUND_TRANSACTION_ERROR: 'REFUND_TRANSACTION_ERROR',
  SET_CREDIT_USAGE_ERROR: 'SET_CREDIT_USAGE_ERROR',
  SET_DEFAULT_CARD_ERROR: 'SET_DEFAULT_CARD_ERROR',
  GET_CREDIT_ERROR: 'GET_CREDIT_ERROR',
  GET_REWARD_ERROR: 'GET_REWARD_ERROR',
  GET_GIFT_CARD_CREDIT_ERROR: 'GET_GIFT_CARD_CREDIT_ERROR',
  NO_CARDS_ON_FILE: 'NO_CARDS_ON_FILE',
  ATTACH_AND_COMBINE_ERROR: 'ATTACH_AND_COMBINE_ERROR',
  FETCH_PAYTRONIX_ACCOUNT_ERROR: 'FETCH_PAYTRONIX_ACCOUNT_ERROR',
  FETCH_PAYMENT_PROFILE_ERROR: 'FETCH_PAYMENT_PROFILE_ERROR',
  INVALID_GIFT_CARD_USER_ERROR: 'INVALID_GIFT_CARD_USER_ERROR',
  GIFT_CARD_ASSOCIATED_WITH_ANOTHER_ACCOUNT_ERROR:
    'GIFT_CARD_ASSOCIATED_WITH_ANOTHER_ACCOUNT_ERROR',
  UNABLE_TO_REDEEM_GIFT_CARD_USER_ERROR: 'UNABLE_TO_REDEEM_GIFT_CARD_USER_ERROR',
  ERROR_NOT_HANDLED: 'ERROR_NOT_HANDLED',
  INVALID_LOCATION_ERROR: 'INVALID_LOCATION_ERROR',
  PAYMENT_NOT_CAPTURED_ERROR: 'PAYMENT_NOT_CAPTURED_ERROR',
};
